import React, {useEffect, useState} from 'react';
import Paper from '@material-ui/core/Paper';
import './ContingentTranslate';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { loadDateReport, contingentModule, saveCause, exportData, saveTechnicalError } from './ContingentDucks';
import StaticTablePagination from '../../_ui/Table/StaticTablePaginated';
import { ReportColumns } from '../../components/PageReport/ReportColumns'
import useTableFilter from '../../components/TableFilter/useTableFilter';
import ModalReportCard from '../../components/PageReport/ModalReportCard'
import useSimpleModal from '../../components/_hooks/useSimpleModal';
import ColorInfo from '../../components/PageReport/ColorInfo'
import useUser from '../LoginPage/useUser';
import { ROLES, ROLES_ADMIN } from '../../_helpers/Constants';
import FilterTreeSelect from '../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
  monthCurrent,
  createTableCell,
  getLastDayOfMonth,
  isTemporaryEditWindowOpen,
  getTemporaryEditWindowTimeLeft,
  isTemporaryEditMonth
} from '../../components/PageReport/reportUtils'
import Button from '../../_ui/Button/Button';
import SaveIcon from '@material-ui/icons/Save';
import Autocomplete from '../../components/TableFilter/ColumnsFilters/FilterAutocomplete';
import FilterSelect from '../../components/TableFilter/ColumnsFilters/FilterSelect';
import FilterDatePickerMonth from '../../components/TableFilter/ColumnsFilters/FilterDatePickerMonth';
import moment from 'moment';
import { monitoringVisitModule } from '../MonitoringVisitPage/MonitoringVisitDucks';
import ContingentExportReportModal from './modal/ContingentExportReportModal';
import ContingentApproveModalByParents from './modal/ContingentApproveModalByParents';
import ContingentReportStatusModal from './modal/ContingentReportStatusModal';

export default function ContingentDDOReport() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const user = useUser();
  const roles = user?.roles || [];
  const adminRoles = [
    'ES_GODS',
    'ES_ADMINS'
  ];
  const isAdmin = roles.some(r => adminRoles.includes(r));
  const [days, setDays] = useState([]);
  const reportCardModal = useSimpleModal();
  const exportReportModal = useSimpleModal();
  const openStatusModal = useSimpleModal();
  const [isEdit, setIsEdit] = useState(true);
  const [isShowSum, setIsShowSum] = useState(false)
  const [counterVisitedDays, setCounterVisitedDays] = useState(0);
  const [counterDaysWithoutReason, setCounterDaysWithoutReason] = useState(0);
  const [counterDaysWithReason, setCounterDaysWithReason] = useState(0);
  const [copyFilter, setCopyFilter] = useState();
  const [canUploadPastFile, setCanUploadPastFile] = useState(false);
  const [isTemporaryEditOpen, setIsTemporaryEditOpen] = useState(isTemporaryEditWindowOpen);
  const [currentOrg, setCurrentOrg] = useState(user?.organization_id);
  const [counterWithReasonReference, setCounterWithReasonReference] = useState(0);
  const [counterWithReasonLeaveApplication, setCounterWithReasonLeaveApplication] = useState(0);
  const [counterWithReasonParentStatement, setCounterWithReasonParentStatement] = useState(0);
  const [counterChildDays, setCounterChildDays] = useState(0);
  const [counterVisitSumma, setVisitSumma] = useState(0);
  const [counterTechnicalError, setCounterTechnicalError] = useState(0);
  const getFullYear = new Date().getFullYear();
  const [currentMonth, setCurrentMonth] = useState(monthCurrent(new Date().getMonth() + 1));
  const [isDisabledLocation, setIsDisabledLocation] = useState(false);
  const [userLocationCode, setUserLocationCode] = useState('');
  const [isEditHead, setIsEditHead] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const approvedModal = useSimpleModal();
  const isMarkEnabled = user?.organization?.currentMonthParentAttendanceConfirmation?.isEnable === true;

  const { nextPage, changeFilter, filter } = useTableFilter(filter => {
    let activeMonth = moment(filter.dateMin).format('MM');
    let currentDateMax = moment(filter['dateMin']).format('YYYY')
    const arrDays = createTableCell(getLastDayOfMonth(currentDateMax, activeMonth), currentDateMax, activeMonth);
    if (arrDays.length) {
      setDays(arrDays)
    }
    setCurrentMonth(activeMonth);
    filter['dateMax'] = `${currentDateMax}-${activeMonth}-${getLastDayOfMonth(currentDateMax, activeMonth)}T00:00:00`
    filter['pageSize'] = 26
    const prevMonth = moment().subtract(1, 'month').format('MM');
    if (activeMonth !== prevMonth) {
      filter['attendanceSheetConsentStatus'] = null;
    }
    setCopyFilter({...filter})
    dispatch(loadDateReport({filter}));
  }, {
    pageNumber: 1,
    pageSize: 26,
    dateMin: `${getFullYear}-${currentMonth}-01T00:00:00`
  });
  const statusMap = {
    SIGNED: t('pageReport_statusSIGNED'),
    DENIED: t('pageReport_statusDENIED'),
    UNCONFIRMED: t('pageReport_statusUNCONFIRMED')
  };
  const prevMonth = moment().subtract(1, 'month').format('MM');
  const isPrevMonthSelected = currentMonth === prevMonth;

  const { currentOrgItem } = useSelector(
    state => state[monitoringVisitModule]
  );

  const { report, loadingTable, groupReport, organizations, cause, loadingExport, loadingSave } = useSelector(
    state => state[contingentModule]
  );
  const onExportHandle = () => {
    dispatch(exportData({filter: copyFilter, currentOrg}))
  };

  useEffect(() => {
    changeFilter({
      'serviceProviderLocation': currentOrgItem.legalLocality,
      'serviceProviderId': currentOrgItem.serviceProviderId
    })
  }, [currentOrgItem?.legalLocality])

  useEffect(() => {
    let visitedDays = 0;
    let withoutReason = 0;
    let withReason = 0;
    let withReasonReference = 0;
    let withReasonLeaveApplication = 0;
    let withReasonParentStatement = 0;
    let childDays = 0;
    let visitSumma = 0;
    let technicalError = 0
    report.content.forEach((item) => {
      setCounterVisitedDays(visitedDays += item.visitedDays);
      setCounterDaysWithoutReason(withoutReason += item.unvisitedDaysWithoutReason);
      setCounterDaysWithReason(withReason += item.unvisitedDaysWithReason);
      setCounterWithReasonReference(withReasonReference += item.unvisitedDaysWithReasonReference);
      setCounterWithReasonLeaveApplication(withReasonLeaveApplication += item.unvisitedDaysWithReasonLeaveApplication);
      setCounterWithReasonParentStatement(withReasonParentStatement += item.unvisitedDaysWithReasonParentStatement);
      setCounterTechnicalError(technicalError += item.unvisitedDaysWithReasonTechnicalError)
      setCounterChildDays(childDays += item.childDays);
      setVisitSumma(((visitSumma += parseFloat(item.visitSumma.toFixed(2))) * 100) / 100);
    })
  }, [report]);

  // SD-1604: закрываем временное окно ровно в 22:00, даже если страница не перезагружалась
  useEffect(() => {
    if (!isTemporaryEditOpen) return;
    const timer = setTimeout(() => setIsTemporaryEditOpen(false), getTemporaryEditWindowTimeLeft());
    return () => clearTimeout(timer);
  }, [isTemporaryEditOpen]);

  useEffect(() => {
    if (user) {
      user.roles.forEach((item) => {
        if (item === ROLES.ES_REGION_MIO_EMPLOYEES || item === ROLES.ES_REGION_EMPLOYEES) {
          setIsEdit(false);
          setCurrentOrg(false)
        }
        if (item === ROLES_ADMIN.ES_GODS || item === ROLES_ADMIN.ES_ADMINS) {
          setIsEdit(true);
        }
        if (item === ROLES.ES_SERVICE_PROVIDER_HEADS || item === ROLES.ES_SERVICE_PROVIDER_EMPLOYEES) {
          setIsEditHead(true);
          if (copyFilter?.dateMin) {
            const selectedDate = moment(copyFilter.dateMin);
            const now = moment();

            const isPastMonth = !selectedDate.isSame(now, 'month');
            const isTemporaryEditAllowed =
              isTemporaryEditOpen && isTemporaryEditMonth(selectedDate);

            if (isPastMonth && !isTemporaryEditAllowed) {
              setIsEdit(false);
              setCanUploadPastFile(true);
            } else {
              setIsEdit(true);
            }
          } else {
            setIsEdit(true);
          }
        }
        if ([ROLES.ES_REGION_MIO_EMPLOYEES].includes(item) && user?.legal_region) {
          changeFilter({
            'serviceProviderLocation': user?.legal_region,
          })
          setUserLocationCode(user?.legal_region);
          setIsDisabledLocation(true);
        } else if ([ROLES.ES_REGION_EMPLOYEES].includes(item) && user?.region_code) {
          changeFilter({
            'serviceProviderLocation': user?.region_code,
          })
          setUserLocationCode(user?.region_code);
          setIsDisabledLocation(true);
        } else if (item === ROLES.ES_GODS) {
          setIsShowSum(true);
        }
      })
    }
  }, [user, copyFilter, isTemporaryEditOpen])

  return (
    <>
      <Paper className="pb3 pt1 px3 mt2" style={{ minWidth: 2500 }}>
        <div className="flex justify-between items-center">
          <h3>{t('contingentPage_reportTitle')}</h3>
        </div>
        <div className="flex justify-between items-center mb2">
          <Box className="flex justify-between items-center">
            <Box className="flex justify-between items-center mr2">
              <Typography style={{fontSize: '12px', width: '100px'}}> { t('contingentPage_tableFor') } </Typography>
              <Box style={{width: '250px'}}>
                <FilterDatePickerMonth
                  name="dateMin"
                  lang={i18n.language}
                  currentMonth={currentMonth}
                />
              </Box>
            </Box>
            {
              (isAdmin || (!isEdit && !currentOrg)) &&
              <>
                <Box className="flex justify-between items-center mr2">
                  <Typography style={{fontSize: '12px', width: '200px'}}>{t('colleagues_location')}</Typography>
                  <FilterTreeSelect
                    lookupId="60"
                    name="serviceProviderLocation"
                    lang={i18n.language}
                    isEdit={isDisabledLocation}
                    userLocationCode={userLocationCode}
                    filter={item => item.ARM_gu === 'true'}
                  />
                </Box>
                <Box className="flex justify-between items-center mr2">
                  <Typography style={{fontSize: '12px', width: '140px'}}>{t('colleagues_organizations')}</Typography>
                  <Autocomplete
                    name="serviceProviderId"
                    options={organizations}
                  />
                </Box>
              </>
            }
            {
              (currentOrg || (!isEdit && copyFilter.serviceProviderId)) &&
              <FilterSelect
                name="groupId"
                options={groupReport}
                fullWidth={false}
                style={{ marginRight: 10, width: 150 }}
                placeholder={t('contingentPage_group')}
              />
            }
            {isPrevMonthSelected && (
              <Box className="flex justify-between items-center mr2">
                <Typography style={{fontSize: '12px', width: '100px'}}>
                  {t('contingentPage_status')}
                </Typography>
                <Box style={{ width: '250px' }}>
                  <FilterSelect
                    name="attendanceSheetConsentStatus"
                    options={Object.entries(statusMap).map(([value, label]) => ({
                      code: value,
                      [`${i18n.language}_name`]: label
                    }))}
                    style={{ width: 200 }}
                    fullWidth={false}
                  />
                </Box>
              </Box>
            )}
          </Box>
          <div style={{display:"flex", gap:'10px'}}>
            {isAdmin && (
              <Button
                onClick={exportReportModal.open}
                icon={<SaveIcon fontSize="small" className="mr1" />}
                text={t('contingentPage_exportTabel_btn')}
              />
            )}
            <Box className="flex justify-between items-center">
              <Button
                onClick={onExportHandle}
                icon={<SaveIcon fontSize="small" className="mr1" />}
                text={t('colleagues_export_btn')}
                loading={loadingExport}
              />
              <Box className='mr2'></Box>
              <ColorInfo />
            </Box>
          </div>
        </div>
        {  
          (!currentOrg && (!isEdit && !copyFilter.serviceProviderLocation)) &&
          <FormHelperText error style={{marginBottom: '10px', fontSize: '14px'}}>{t('contingentPage_isShowDataTable')}</FormHelperText>
        }
        <Box className='reportСard reportСardDDO'>
          <StaticTablePagination
            sortable={false}
            loading={loadingTable}
            columns={ReportColumns({
              t,
              lang: i18n.language,
              days,
              open: reportCardModal.open,
              cause,
              isShowSum,
              isEditHead: isEditHead,
              isEdit: isEdit,
              checkedList,
              setCheckedList,
              reportList: report.content,
              isMarkEnabled,
              openStatusModal:openStatusModal.open,
              isPrevMonthSelected
            })}
            currentlyResizing={true}
            data={report.content.length ? [...report.content, {
              name: '',
              visitedDays: counterVisitedDays,
              totalFinish: true,
              unvisitedDaysWithoutReason: counterDaysWithoutReason,
              unvisitedDaysWithReason: counterDaysWithReason,
              unvisitedDaysWithReasonReference: counterWithReasonReference,
              unvisitedDaysWithReasonLeaveApplication: counterWithReasonLeaveApplication,
              unvisitedDaysWithReasonParentStatement: counterWithReasonParentStatement,
              unvisitedDaysWithReasonTechnicalError: counterTechnicalError,
              childDays: counterChildDays,
              visitSumma: counterVisitSumma,
            }] : []}
            totalElements={report.totalElements ? report.totalElements + 1 : report.totalElements}
            onClickLoadMore={() => nextPage()}
            isNeedCustomToolbar={isMarkEnabled}
            CustomToolbar={
              isMarkEnabled
                ? () => (
                  <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                    <Button
                      text={t('contingentPage_markAsApproved')}
                      disabled={checkedList.length === 0}
                      onClick={approvedModal.open}
                    />
                  </div>
                )
                : undefined
            }
          />
        </Box>
        { reportCardModal.isOpen &&
          <ModalReportCard
            {...reportCardModal}
            close={reportCardModal.close}
            saveCause={saveCause}
            cause={cause}
            loadingSave={loadingSave}
            isEdit={isEdit}
            saveTechnicalError={saveTechnicalError}
            filter={copyFilter}
            canUploadPastFile={canUploadPastFile}
          />
        }
        { exportReportModal.isOpen &&
          <ContingentExportReportModal
            {...exportReportModal}
          />
        }
        {approvedModal.isOpen && (
          <ContingentApproveModalByParents
            open={approvedModal.isOpen}
            onClose={approvedModal.close}
            checkedList={checkedList}
            reportList={report.content}
            filter={copyFilter}
            setCheckedList={setCheckedList}
          />
        )}
        { openStatusModal.isOpen &&
          <ContingentReportStatusModal
            {...openStatusModal}
            close={openStatusModal.close}
          />
        }
      </Paper>
    </>
  );
}
